import React from "react";
import ReactDOM from "react-dom/client";
// react library for routing
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "quill/dist/quill.core.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { reducers } from "reducers";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { NotificationProvider } from "components/CommonComponents/NotificationProvider";
import { AuthProvider } from "pages/Auth/AuthContext";

import ChannelPartnerLayout from "layouts/ChannelPartner";
import { ROLE_BASED_DEFAULT_ROUTE } from "constants/CommonConstants";
import InstructorLayout from "layouts/Instructor";
import SuperAdminLayout from "layouts/SuperAdmin";

const root = ReactDOM.createRoot(document.getElementById("root"));

const store = configureStore({ reducer: reducers });
export default store;

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authData = JSON.parse(localStorage.getItem("p")) || {};
  const token = authData.token; //get the token from localstorage
  const role = authData.role; //get the trole from localstorage

  // React.useEffect(() => {
  //   const body = document.body;

  //   function applySidebarState() {
  //     const isMobile = window.innerWidth < 1030;

  //     if (isMobile) {
  //       // MOBILE → sidebar should be closed
  //       body.classList.remove("g-sidenav-pinned");
  //       document.body.classList.remove("g-sidenav-show");
  //       body.classList.add("g-sidenav-hidden");
  //     } else {
  //       // DESKTOP → sidebar should be open
  //       body.classList.add("g-sidenav-pinned");
  //       body.classList.remove("g-sidenav-hidden");
  //     }
  //   }

  //   applySidebarState();

  //   // Update state on window resize
  //   window.addEventListener("resize", applySidebarState);

  //   // Cleanup on unmount
  //   return () => window.removeEventListener("resize", applySidebarState);
  // }, []);

  React.useEffect(() => {
    //if not login in and token not found
    if (!token) {
      if (!location.pathname.startsWith("/auth")) {
        navigate("/auth/login", { replace: true });
      }
      return;
    }

    // Logged in user -> redirect as per define default route/page to them
    const defaultRoute = ROLE_BASED_DEFAULT_ROUTE[role];
    //check if login user is in auth page -> send true ( login/register pages)
    const isOnAuthRoute = location.pathname.startsWith("/auth");
    // Check if user is on root URL "/"
    const isRoot = location.pathname === "/";

    // Redirect logged-in user from auth/ pages
    // to their role-based default page
    if (defaultRoute && (isOnAuthRoute || isRoot)) {
      navigate(defaultRoute, { replace: true });
    }
  }, [token, role, location.pathname, navigate]);

  return (
    <Routes>
      <Route path="/super-admin/*" element={<SuperAdminLayout />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/instructor/*" element={<InstructorLayout />} />
      <Route path="/channel-partner/*" element={<ChannelPartnerLayout />} />
      <Route path="*" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  );
};

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>
        {" "}
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);
